import { client } from 'util/sdk';
import { GET, POST, DELETE, PUT } from 'util/api';

const returnModelList = { name: 'coreAuthOptions' };
const returnModelSingle = { name: 'coreAuthOption' };

export const load = (fspId) =>
  client.executeRequest(GET, `/v2/fsps/${fspId}/loan-auth-options`, {
    returnModel: returnModelList,
  });

export const create = (
  { fspId, coreAuthOptionId, authDataLabel, description },
  auth
) =>
  client.executeRequest(POST, `/v2/admin/fsps/${fspId}/loanAuthOptions`, {
    data: {
      coreAuthOptionId,
      authDataLabel,
      description,
    },
    queryParams: {
      adminUserId: auth.id,
    },
    returnModel: returnModelSingle,
  });

export const remove = ({ fspId, id, updatedAt, createdAt }, auth) =>
  client.executeRequest(
    DELETE,
    `/v2/admin/fsps/${fspId}/loanAuthOptions/${id}`,
    {
      queryParams: {
        adminUserId: auth.id,
        lastUpdatedAt: updatedAt || createdAt,
      },
      returnModel: returnModelSingle,
    }
  );

export const update = (
  {
    fspId,
    id,
    coreAuthOptionId,
    authDataLabel,
    description,
    updatedAt,
    createdAt,
  },
  auth
) =>
  client.executeRequest(PUT, `/v2/admin/fsps/${fspId}/loanAuthOptions/${id}`, {
    data: {
      coreAuthOptionId,
      authDataLabel,
      description,
    },
    queryParams: {
      adminUserId: auth.id,
      lastUpdatedAt: updatedAt || createdAt,
    },
    returnModel: returnModelSingle,
  });

export const importAndReset = ({ fspId, fsploanauthopt }, auth) =>
  client.executeRequest(
    POST,
    `/v2/admin/fsps/${fspId}/loanAuthOptions/import`,
    {
      data: {
        loanAuthOptions: fsploanauthopt,
      },
      queryParams: {
        adminUserId: auth.id,
      },
      returnModel: returnModelList,
    }
  );
